import lunr from "/home/runner/work/reactodia.github.io/reactodia.github.io/node_modules/lunr/lunr.js";
export const removeDefaultStopWordFilter = [];
export const language = ["en"];
export const searchIndexUrl = "search-index{dir}.json?_=465c09dd";
export const searchResultLimits = 8;
export const fuzzyMatchingDistance = 1;